<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {}
  },
  methods: {},
}
</script>

<style lang='scss'></style>
